import request from "@/http.js";


let data={
  selectPicture:"notice/selectPicture", // 轮播图
  newsNotice:"newsNotice/noticeList",   //新闻列表
  friendlyLink:"friendlyLink/list",   //新闻列表
}


export function selectPicture(query) {
  return request({
      url: data.selectPicture,
      method: "post",
      data: query
  });
}

export function getNewsNotice(query) {
  return request({
      url: data.newsNotice,
      method: "post",
      data: query
  });
}

export function getFriendlyLink(query) {
  return request({
      url: data.friendlyLink,
      method: "post",
      data: query
  });
}




// WEBPACK FOOTER //
// ./src/api/home/index.js